<template>
  <div class="header">
    <div class="header-wrap">
      <div class="left-wrap">
        <router-link class="homeLink" to="/">
          <img class="logo" src="@/assets/images/header/logo.png" alt="logo">
        </router-link>

        <template v-if="$route.path !== '/'">
          <div class="divider"></div>
          <div class="links" v-show="linksShow">
            <div class="linkWrap">
              <router-link class="link" to="/clips">
                <span class="linkName" :class="{current: $route.path.indexOf('/clips') === 0}">{{$t('main.learn')}}</span>
              </router-link>
            </div>
            <div class="linkWrap">
              <router-link class="link" to="/courses">
                <span class="linkName" :class="{current: $route.path.indexOf('/courses') === 0}">{{$t('main.course')}}</span>
              </router-link>
            </div>
            <div class="linkWrap">
              <router-link class="link" to="/ebook">
                <span class="linkName" :class="{current: $route.path.indexOf('/ebook') === 0}">{{$t('main.ebook')}}</span>
              </router-link>
            </div>
            <div class="linkWrap" v-show="!isMember">
              <router-link class="link" to="/pricing">
                <span class="linkName" :class="{current: $route.path.indexOf('/pricing') === 0}">{{$t('main.member_ship')}}</span>
              </router-link>
            </div>
            <div class="linkWrap">
              <a class="link" href="https://support.fluenday.com/en/support/home" target="_blank">
                <span class="linkName">{{$t('web.help_center')}}</span>
              </a>
            </div>
          </div>
        </template>
      </div>

      <div class="right-wrap">
        <div class="changeLearnLangWrap" v-if="['/clips', '/ebook'].includes($route.path)">
          <el-dropdown trigger="click" placement="bottom" @command="changeLearnLangHandle">
            <span class="el-dropdown-link">
              <img class="flagImage" :src="require(`@/assets/images/flag/${learnLanguage}.png`)" alt="flag">
            </span>
            <el-dropdown-menu slot="dropdown">
              <template v-for="(language, i) in learnLangs">
                <div v-if="i" class="divider" :key="i"></div>
                <el-dropdown-item :class="{ active: learnLanguage === language }" :key="language" :command="language">
                  <div class="langWrap">
                    <img class="flagImage" :src="require(`@/assets/images/flag/${language}.png`)" alt="flag">
                    <div class="learnLang">{{$t(`web.learn_${langsData[language]['englishName'].toLowerCase()}`)}}</div>
                  </div>
                </el-dropdown-item>
              </template>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="loginWrap">
          <template v-if="userInfo">
            <el-popover popper-class="userPanel" placement="bottom" trigger="click">
              <div class="userInfoItem">
                <div class="itemKey">{{$t('buy.account')}}</div>
                <div class="itemVal">{{userInfo.NickName}}</div>
              </div>
              <div class="userInfoItem">
                <div class="itemKey">{{$t('buy.email')}}</div>
                <div class="itemVal">{{userInfo.Email}}</div>
              </div>
              <div class="userInfoItem">
                <div class="itemKey">{{$t('buy.sign_in_method')}}</div>
                <div class="itemVal">{{getSignInMethodTrans()}}</div>
              </div>
              <div class="userInfoItem">
                <div class="itemKey">{{$t('buy.account_type')}}</div>
                <div class="itemVal">{{$t(`buy.${accountType}`)}}</div>
              </div>
              <div class="logoutBtn" @click="logoutHandle">{{$t('main.logout')}}</div>
              <div class="avatarWrap" slot="reference">
                <img class="avatar" src="@/assets/images/header/avatarUnlogin.png" alt="avatar">
                <img v-if="isMember" class="crown" src="@/assets/images/header/crown.png" alt="crown">
              </div>
            </el-popover>
          </template>
          <template v-else>
            <div class="loginBtn" @click="signIn">{{$t('main.sign_in')}}</div>
          </template>
        </div>
        <div class="divider"></div>
        <div class="changeBaseLangWrap">
          <el-dropdown trigger="click" placement="bottom" @command="changeBaseLangHandle">
            <span class="el-dropdown-link">
              <p class="languageNameBase">
                <svg t="1684121966038" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3244" width="28" height="28"><path d="M501.826801 445.688735c0-0.076748 0.100284-0.12689 0.100284-0.202615-0.100284-0.731664-0.302899-1.388627-0.302899-1.868557C501.675352 444.300109 501.727541 444.98163 501.826801 445.688735L501.826801 445.688735zM648.208706 605.547583 648.208706 605.547583c0 0-0.103354 0-0.103354-0.052189C648.157541 605.547583 648.208706 605.547583 648.208706 605.547583L648.208706 605.547583zM651.943774 606.027513c-0.909719-0.152473-2.926656 0.100284-3.734044-0.479931C647.703193 607.263667 648.510582 607.918583 651.943774 606.027513L651.943774 606.027513zM509.349125 129.204687c-210.536041 0-381.245004 170.685427-381.245004 381.219421 0 210.536041 170.708963 381.195885 381.245004 381.195885 210.533994 0 381.243981-170.658821 381.243981-381.195885C890.593106 299.890115 719.883119 129.204687 509.349125 129.204687L509.349125 129.204687zM752.843812 278.134625c-13.121855 0.378623-22.258956 0.427742-32.860409 7.697309-4.238534 2.927679-7.116071 6.813173-12.516058 8.355295-4.845355 1.363044-10.045797 0.149403-14.839986 1.790786-17.314341 5.853311-14.589276 42.953278-37.402865 37.376259-10.701736-2.64934-18.272155-15.293311-23.673166-23.572882-4.746094-7.29208-13.425777-13.32447-7.571443-22.434965-2.62478 0.705058-5.503341-0.075725-8.128121 0.429789 3.686972-8.025791 15.902178-7.318686 17.921161-11.4334 5.14723-10.298554-13.932314-11.356652-19.333324-12.795421 6.510274-6.915503 9.79304 2.346441 16.202007 0.781806 6.158257-1.538029-3.230578-9.665127-6.963599-10.574846-1.312902-0.326435-23.068392 6.007831-10.500145-5.248537-15.495926-9.91993-31.043017-19.811208-46.538943-29.732162-2.623757 11.030218 20.643156 17.288758 28.266787 21.177322-1.213641 4.541433-8.278547 11.180644-13.679557 9.235338-5.097088-1.817392-3.02694-10.296507-10.750855-9.438976-5.503341 12.795421 11.609409 9.060353 13.224186 16.883529 1.817392 8.933463-6.460132 5.148253-9.691733 4.998851-0.707105-0.026606-6.66377-6.183839-6.967692-1.542122-0.402159 5.526877 9.489118 3.38305 10.147104 8.960069-11.458983 0.478907-17.311271-3.685949-26.700105-9.893324-10.905374-7.242961-16.507976-6.587022-29.882588-6.587022 4.036943-1.639337 9.489118-2.851954 12.923334-5.500271 1.916653-1.438769 9.185196-8.55484 9.689686-10.17064 2.068102-6.839779-0.101307-6.334265-6.66377-10.827603-5.855358-3.987824-12.920264-11.154038-19.986193-12.56927-25.645077-5.098111-7.876388 23.14514-27.360138 27.030633 0.352017 0.025583 0.707105 0.025583 1.010003 0.025583l-1.110287 0c0 0 0.100284 0 0.100284-0.025583-4.493338-0.176009-12.922311-1.260713-15.84999 1.136893-2.01796 1.664919-2.220574 8.378831-4.493338 10.80202-4.037966 4.339842-10.144034 5.198395-14.989389 8.328689-4.746094 3.053546-15.195074 10.901281-17.97028 16.228613-10.246365 19.608593 23.118534 25.667589 35.787064 31.420617 5.703909 2.575662 22.410406 6.131651 25.541723 10.447956 4.188392 5.804193-3.583618 11.256368 5.097088 15.3455 2.827395 1.312902 8.529257 1.565658 10.902304-1.110287 3.938706-4.39203-1.564635-5.399987-2.472308-10.474562-1.817392-9.767458 1.160429-5.879917 6.108115-9.514701 9.995655-7.368828 7.722892-7.824199 4.137227-19.609617-1.713015-5.477758-7.972579-20.771069-2.421142-24.810059 7.218402-5.298679 22.61302 2.827395 28.16548 3.535523 6.461155 0.781806 10.145058 9.741875 13.678534 13.374612 2.320858 2.423189 6.511297 7.597025 10.549264 7.042393 6.511297-0.883113 3.787256-6.53688 7.571443-9.162684 10.092869-6.990205 12.719696 2.498914 16.756639 12.013615 3.787256 8.909927 7.371898 12.215206 14.083763 17.944697 3.130294 2.674922 16.809851 12.189623 15.496949 18.046005-0.857531 3.962242-16.504906 9.943466-20.695345 11.254322-15.295358 4.845355-43.964304-7.924483-47.044456 16.32992 5.957689-2.222621 22.815635-16.002462 27.863604-9.465582 2.323928 2.977821-1.817392 7.269567-0.856507 10.220782 2.874467 8.833179 9.740852 5.756097 16.806781 4.317329-0.454348 0.328481-0.957815 0.580215-1.463328 0.832971 9.741875-5.024433 8.731872-3.987824 13.175067-12.113899 1.51347-2.651386 3.682879-9.085936 5.752004-10.980076 7.065929-6.511297 8.17724-2.044566 12.520151 2.978844 1.209548 1.338485 12.010545 16.959254 8.175193 16.204054-12.619412-2.52552-24.784476-2.221598-35.232432 4.692882-6.055926 4.012384-11.761881 9.388834-18.978237 12.038174-1.718131 0.63138-14.536065 1.817392-13.024641-0.352017 2.221598-3.180436 9.843182-5.27412 12.821003-8.707312-8.278547-3.432169-15.243169 4.13825-21.75549 8.55484-6.916527 3.282766-8.531304 9.364275-14.436804 14.738679-2.573615 2.323928-7.468089 2.726088-9.993608 5.806239-2.424212 2.977821-2.775206 7.670703-5.098111 10.499122-1.614777 1.994424-5.753027 0.781806-7.467065 3.759627-2.224668 3.9121 2.016937 7.546883 1.056052 10.348696-1.665942 5.121648-11.405771 9.462512-15.142885 13.121855 0.505513-0.478907 0.960885-0.957815 1.467421-1.462305-3.736091 3.935636-8.483208 6.813173-11.410887 11.356652 1.363044 6.411013 5.553483 21.728884 4.444219 25.26236-3.939729 11.584849-11.511171-6.308683-14.538111-10.927887-10.601452-15.900132-31.649837-5.248537-46.034453-3.936659-18.424628 1.688455-36.44505 25.565259-25.086351 44.974307 5.451152 9.286504 14.58723 12.894681 25.13547 10.750855 9.338692-1.917676 12.165064-15.018042 20.998243-15.270798 16.202007-0.428765 0.352017 15.876596-1.060145 21.881356-1.312902 5.553483 2.020006 6.057973 7.722892 7.421017 4.188392 1.010003 10.197246-1.791809 13.879102 0.604774 2.272763 1.515516 2.170432 9.845229 5.350868 7.219425-6.258541 5.149277-4.795213 17.417695 1.6158 21.831214 7.066953 4.922103 15.394618 0.355087 22.816658 2.24718 13.981433 3.584642 7.317663-1.062192 19.585057-8.479115 8.328689-4.998851 9.691733 0.933255 15.344476 0.957815 3.886517 0.025583 6.308683-5.550413 12.769838-3.935636 5.250584 1.335415 7.317663 5.399987 13.628392 6.333242 2.572592 0.378623 5.248537-0.984421 7.670703-0.706081 11.661597 1.286296 20.544919 8.706289 29.67895 15.443737 7.573489 5.503341 12.570293 4.393054 21.35333 6.916527 6.460132 1.845021 18.322297 11.156084 17.7165 19.333324-0.102331 1.463328-5.704932 8.807596-6.712889 12.139481 1.663896 1.133823 13.120832-1.415232 16.454764-1.665942-1.111311 1.288343-8.884344 6.764054-8.884344 3.837398 0 1.512447 5.550413 4.565992 6.863315 5.525853 4.088108-13.224186 10.750855-4.718465 18.777669-1.438769 6.865361 2.77623 15.294334 2.927679 22.614044 4.669346 6.158257 1.488911 19.786649 5.653767 24.430412 10.725272 5.501294 6.082532 1.716084 16.000416-2.422166 22.059412-5.350868 7.922437-13.427824 10.978029-16.70752 20.342304-2.674922 7.393387-0.657986 14.889105-2.170432 23.091928-2.02103 11.130502-3.685949 7.241938-10.80202 14.005992-6.057973 5.730515-0.152473 4.746094-8.328689 8.378831-8.229428 3.66139-15.496949 2.574638-21.200858 11.611455 0.202615-0.557702 0.403183-1.162476 0.555655-1.741667-2.423189 3.329838-3.63683 10.29753-4.746094 12.516058-2.876514 5.753027-6.863315 9.44-11.406794 14.234189-1.714038 1.817392-17.766642 23.724331-18.674315 22.008246-1.213641-2.322905-13.833053 2.270716-14.435781-1.00898 0.503467 2.775206-0.101307 1.816369 3.02694 3.432169-2.927679 17.96721-10.500145 20.695345-28.164456 20.845771 1.51347 8.631588-6.460132 6.915503-10.095939 11.558244-2.169409 2.725064-3.230578 10.399861-4.691859 13.882172-0.959861 2.220574-7.824199 11.053754-7.824199 12.818957 0 1.6158 2.320858 3.986801 4.489244 6.208399-12.464893 2.52552-25.184589 4.239558-38.056758 5.250584 2.423189-3.027963 2.977821-5.702885-4.694929-6.058996 2.070148-5.600555 6.916527-8.78099 8.93551-14.235213 0.958838-2.52245 0.149403-3.53143 1.00591-6.053879 2.778276-8.785084 1.566682-5.451152 0-12.215206-3.682879-15.953344 1.314948-20.293185 5.65479-34.880415 4.492314-14.991436 4.090155-34.374902 6.916527-50.526767 1.311879-7.721869 3.53143-23.77345 0.857531-31.067576-2.977821-8.226359-16.303314-14.687514-22.36231-20.240997-8.631588-7.824199-13.224186-16.302291-19.584034-25.993001-3.231601-4.947685-6.965645-9.767458-9.490142-15.144932-5.451152-11.455913 0-4.641717 0.910743-11.379165 0.857531-6.537903-0.807389-12.393261 1.814322-19.23304 2.829442-7.571443 9.995655-12.317537 12.367679-19.962657 2.12029-6.815219 0.555655-15.343453-6.461155-17.61724-3.885494-1.286296-8.225335 1.641383-12.113899 1.010003-5.452175-0.883113-11.660574-4.945639-15.950274-8.229428-5.955642-4.542456-8.229428-11.960403-14.58723-16.252149-5.350868-3.609201-9.086959-1.463328-14.789844-3.131317-5.955642-1.766226-9.641591-9.111518-14.436804-11.407817-7.218402-3.432169-11.256368 1.515516-18.827811 0.505513-6.460132-0.857531-16.352433-8.025791-22.410406-10.701736-12.266371-5.500271-19.735483-11.582803-24.629957-24.025183-4.240581-10.701736-10.349719-15.697517-17.568121-24.580838-7.317663-9.036817-9.588379-16.709567-20.894889-19.132756-1.311879-0.25071 2.775206 9.491165 3.230578 10.272971 3.985778 7.444553 10.04375 14.260795 14.94027 21.224394 7.16826 10.222829 4.088108 12.140505-3.230578 2.24718-8.278547-11.30651-17.97028-22.563902-25.185612-34.551934-2.778276-4.54041-2.222621-7.468089-6.713912-11.758812-4.340865-4.163833-10.045797-6.184863-14.436804-10.120498-15.747659-14.184047-18.625196-33.137725-16.859993-53.352115 0.607844-6.588045 3.031033-11.837606 1.919722-18.172895-0.808412-5.27412-3.937682-9.641591-7.824199-13.502525-1.261737-1.994424-4.39203-6.889921-4.594645-7.191796-3.533476-5.955642-6.358825-11.811-12.011568-16.681938-3.28072-2.827395-11.711739-9.364275-19.685341-14.892175 35.734876-44.518936 82.477456-79.827093 136.081305-101.733009 0.405229 2.674922 1.565658 5.374404 3.332908 7.950066 4.391007 6.53688 8.579399 6.005784 17.159822 7.824199-0.907673 9.993608-12.567223 10.070356-20.49273 8.983605-9.388834-1.309832-19.332301-4.41352-27.508517 3.838422 4.493338 2.725064 16.910135 13.274328 15.244192 2.246157 9.03477-0.455371 17.767666-0.733711 26.599821 0.353041 3.535523 0.428765 15.446807 4.415566 18.627243 2.599198 1.363044-0.757247 2.775206-7.421017 4.188392-9.465582-2.473331 0-5.198395-1.25969-7.671727-1.033539 5.853311-7.494695 11.659551-1.589195 19.130709 1.840928-8.229428 4.972245-3.38305 16.936741 4.692882 7.218402 6.563486-7.973602-1.6158-13.753235-9.994632-18.399045 8.428973-10.549264 13.629415-11.506055 21.553898 0.405229 1.312902-7.344269 7.218402-4.41659 13.426801-3.861958l0-1.840928c-2.725064 0.073678-5.603625-1.515516-8.328689-1.212618 6.308683-10.070356 2.269693-12.366655 11.30651-15.672958 7.16826-2.599198 27.66099-0.176009 30.184463-6.913457-14.334473 2.775206-31.646767 3.456728-44.621267 9.967002-5.550413 2.827395-12.214183 11.685133-17.767666 5.9055-5.703909-5.9055 4.090155-15.421224 9.086959-18.322297l-1.210571 0c22.713304-4.819772 46.233997-7.41897 70.313416-7.41897 15.597233 0 30.891568 1.160429 45.88198 3.230578-5.149277 2.725064-1.311879 4.54041-5.098111 7.342222-7.215332 5.326309-20.087501 9.767458-28.66997 13.123902 10.95347-0.025583 37.402865 10.246365 42.500976-5.098111-3.533476-0.529049-7.066953-1.084705-10.601452-1.614777 6.613628-4.367471 13.982456-7.899924 21.705348-10.499122 69.657476 13.805424 131.642203 49.13814 178.785919 98.731652C753.500774 278.134625 753.197876 278.108019 752.843812 278.134625L752.843812 278.134625zM814.576805 411.971819c0.604774-1.339508 2.068102-1.793856 2.674922-2.87856 1.258667-2.346441 0.958838-3.911076 2.573615-5.9055 1.663896-2.170432 3.936659-2.674922 5.804193-4.366448 0.75827-0.681522 1.161453-1.312902 1.514493-1.943258 5.601578 15.69854 10.095939 31.901571 13.374612 48.582485-0.099261 0.102331-0.151449 0.278339-0.300852 0.378623-0.808412 0.657986-6.160303 1.438769-7.269567 1.488911-3.835352 0.152473-6.712889-2.422166-9.487072-4.845355-2.829442-2.446725-6.15928-5.727445-8.179286-8.90788-2.119267-3.38305-0.807389-6.889921-0.655939-10.750855C814.777373 419.566798 813.162596 414.897452 814.576805 411.971819L814.576805 411.971819zM818.91767 586.769914c-6.563486-5.702885-14.284331-13.326517-18.930141-20.695345-4.995781-7.850805-1.917676-15.950274-1.562589-24.936949 0.302899-7.570419-3.382027-18.323321-0.151449-25.136493 1.465374-3.130294 4.845355-4.13825 6.207375-6.713912 3.027963-5.374404 2.323928-9.035794 5.955642-13.678534 3.938706-4.995781 9.187243-6.208399 13.530155-10.093892 4.541433-4.114714 4.389984-7.345292 7.268544-12.595876 2.118244-3.858888 7.065929-10.246365 11.759835-13.602809 2.52552 16.657378 3.88754 33.743522 3.88754 51.108005 0 30.034037-4.037966 59.159378-11.409864 86.895069C829.112869 595.703377 823.965639 591.161944 818.91767 586.769914L818.91767 586.769914zM818.91767 586.769914" fill="#ffffff" p-id="3245"></path></svg>
                <span style="margin-left:10px">{{langsData[userLanguage]['fullName']}}<i class="el-icon-arrow-down el-icon--right"></i></span>
              </p>
            </span>
            <el-dropdown-menu slot="dropdown">
              <template v-for="language in baseLangs">
                <el-dropdown-item :key="language" :command="language">
                  <p class="languageName">{{langsData[language]['fullName']}}</p>
                </el-dropdown-item>
              </template>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

        <div class="menuBtn" v-if="$route.path !== '/'" @click="menuShow = !menuShow">
          <svg t="1695719166873" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2457" width="24" height="24"><path d="M375.872 853.312H89.6c-26.624 0-46.912-20.928-46.912-48.256 0-27.392 20.288-48.32 46.912-48.32h286.272c26.624 0 46.976 20.928 46.976 48.32a47.744 47.744 0 0 1-46.976 48.256zM375.872 560.32H89.6C62.976 560.32 42.688 539.392 42.688 512s20.288-48.32 46.912-48.32h286.272c26.624 0 46.976 20.928 46.976 48.32a47.744 47.744 0 0 1-46.976 48.32zM375.872 267.264H89.6c-26.624 0-46.912-20.928-46.912-48.32 0-27.328 20.288-48.256 46.912-48.256h286.272c26.624 0 46.976 20.928 46.976 48.256a47.744 47.744 0 0 1-46.976 48.32z" fill="#ffffff" p-id="2458"></path><path d="M311.744 853.312c-26.56 0-46.912-20.928-46.912-48.256 0-27.392 20.352-48.32 46.912-48.32H934.4c26.624 0 46.912 20.928 46.912 48.32 0 27.328-20.288 48.256-46.912 48.256H311.744c1.6 0 1.6 0 0 0zM311.744 560.32c-26.56 0-46.912-20.928-46.912-48.32s20.352-48.32 46.912-48.32H934.4c26.624 0 46.912 20.928 46.912 48.32s-20.288 48.32-46.912 48.32H311.744c1.6 0 1.6 0 0 0zM311.744 267.264c-26.56 0-46.912-20.928-46.912-48.32 0-27.328 20.352-48.256 46.912-48.256H934.4c26.624 0 46.912 20.928 46.912 48.256 0 27.392-20.288 48.32-46.912 48.32H311.744c1.6 0 1.6 0 0 0z" fill="#ffffff" p-id="2459"></path></svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Vuex from 'vuex'
  import constants from '@/utils/constants'

  export default {
    data() {
      return {
        langsData: constants.langsData,
        menuShow: false
      }
    },
    inject: ['signIn'],
    computed: {
      ...Vuex.mapGetters(['userLanguage', 'learnLanguage', 'userInfo', 'isMember', 'accountType']),
      baseLangs() {
        if (this.$route.name === 'Clips') {
          return constants.langsData[this.learnLanguage]['clipsTrans']
        } else if (this.$route.name === 'Courses') {
          return constants.langsData[this.learnLanguage]['courseTrans']
        } else if (this.$route.name === 'Ebook') {
          return constants.baseLangs.filter(lang => this.learnLanguage !== lang)
        } else {
          return constants.baseLangs
        }
      },
      learnLangs() {
        return constants.learnLangs
      },
      linksShow() {
        if (window.screen.width < 768) {
          return this.menuShow
        } else {
          return true
        }
      }
    },
    methods: {
      changeBaseLangHandle(lang) {
        this.$store.commit('set_userLanguage', lang)
      },
      changeLearnLangHandle(lang) {
        this.$store.commit('set_learnLanguage', lang)
      },
      async logoutHandle() {
        let loading = this.$loading()
        await this.$store.dispatch('logout')
        loading.close()
      },
      getSignInMethodTrans() {
        let signInMethod = this.userInfo.FromType
        if (signInMethod === 'em') {
          return this.$t('buy.Email')
        } else if (signInMethod === 'ai') {
          return this.$t('buy.Apple')
        } else if (signInMethod === 'gg') {
          return this.$t('buy.Google')
        } else if (signInMethod === 'fb') {
          return this.$t('buy.Facebook')
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .el-dropdown-menu {
    padding: 0;
    .el-dropdown-menu__item {
      display: flex;
      flex-direction: column;
      line-height: unset;
      padding: 2px 20px;
      .languageName {
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        font-weight: bold;
      }
      .langWrap {
        display: flex;
        align-items: center;
        gap: 8px;
        .flagImage {
          margin: 10px 0;
          width: 30px;
          border-radius: 30px;
          border: 1px solid #C4C4C4;
          box-sizing: border-box;
        }
        .learnLang {
          font-weight: 500;
          font-size: 14px;
          color: #000000;
        }
      }
      &:hover {
        .langWrap {
          .learnLang {
            color: #66B1FF;
          }
        }
      }
      &.active {
        background: #ECF5FF;
        .langWrap {
          .learnLang {
            color: #66B1FF;
          }
        }
      }
    }
    .divider {
      width: 100%;
      height: 1px;
      background: #ddd;
      box-sizing: border-box;
    }
  }

  .header {
    position: fixed;
    z-index: 1000;
    top: 0;
    background: #000D89;
    width: 100%;
    height: 80px;
    padding: 10px 0;
    box-sizing: border-box;
    font-family: -apple-system, BlinkMacSystemFont, 'Microsoft YaHei', sans-serif;

    .divider {
      margin: 0 20px;
      width: 1px;
      height: 30px;
      background: #D8D8D880;
    }

    &-wrap {
      box-sizing: border-box;
      height: 100%;
      max-width: 1200px;
      min-width: 800px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 auto;
      padding: 0 20px;

      .left-wrap {
        display: flex;
        align-items: center;
        height: 100%;
        .homeLink {
          height: 100%;
          display: flex;
          align-items: center;
        }
        .logo {
          width: 128px;
        }
        .links {
          display: flex;
          .linkWrap {
            margin-right: 30px;
            height: 100%;
            margin-right: 30px;
            .link {
              height: 100%;
              display: flex;
              align-items: center;
              font-family: Roboto;
              cursor: pointer;
              transition: all .3s;
              .linkName {
                font-weight: 400;
                font-size: 14px;
                color: #FFFFFF;
                &.current {
                  font-weight: 900;
                }
              }
              &:hover {
                .linkName {
                  font-weight: 900;
                }
              }
            }
          }
        }
      }

      .nav {
        width: 680px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        .nav-slogan {
          font-family: PingFangSC-Semibold;
          font-weight: 600;
          font-size: 28px;
          color: #FFFFFF;
          text-align: justify;
        }

        &-link {
          display: block;
          height: 100%;
          line-height: 80px;
          text-decoration: none;

          &-text {
            opacity: 0.8;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 18px;
            color: #FFFFFF;
            margin-right: 56px;
            position: relative;
            top: 0;
            transition: 0.3s;

            &:after {
              position: absolute;
              transition: 0.3s;
              content: "";
              width: 0;
              left: 50%;
              bottom: -12px;
              height: 6px;
              border-radius: 3px;
              background: #FFFFFF;
            }
          }

          &:hover {
            .nav-link-text {
              opacity: 1;
              top: -8px;

              &:after {
                width: 80%;
                left: 10%;
              }
            }
          }
        }
      }

      .right-wrap {
        display: flex;
        align-items: center;
        height: 100%;

        .loginWrap {
          display: flex;
          align-items: center;
          cursor: pointer;
          transition: all .3s;
          &:hover {
            opacity: 0.8;
          }
          .avatarWrap {
            position: relative;
            display: flex;
            width: 33px;
            height: 33px;
            border-radius: 33px;
            .avatar {
              width: 33px;
            }
            .crown {
              position: absolute;
              top: -13px;
              right: -7px;
              width: 22px;
            }
          }
          .loginBtn {
            padding: 0 8px;
            height: 26px;
            line-height: 26px;
            border: 1px solid #FFFFFF;
            border-radius: 5px;
            text-align: center;
            font-weight: 400;
            font-size: 12px;
            color: #FFFFFF;
          }
        }

        .changeLearnLangWrap {
          margin-right: 20px;
          display: flex;
          align-items: center;
          height: 100%;
          .el-dropdown-link {
            cursor: pointer;
            .flagImage {
              display: block;
              width: 30px;
              border-radius: 30px;
              border: 1px solid #C4C4C4;
              box-sizing: border-box;
            }
          }
        }

        .changeBaseLangWrap {
          display: flex;
          align-items: center;
          height: 100%;
          .el-dropdown-link {
            cursor: pointer;
            color: white;
            .languageNameBase {
              display: flex;
              align-items: center;
              .el-icon-arrow-down {
                font-size: 12px;
              }
            }
          }
        }

        .menuBtn {
          display: none;
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    .header {
      .divider {
        display: none;
      }
      &-wrap {
        width: 100%;
        min-width: unset;
        max-width: unset;
        .left-wrap {
          .logo {
            width: 100px;
          }
          .links {
            display: block;
            position: absolute;
            top: 80px;
            left: 0;
            width: 100%;
            background: #FFFFFF;
            box-shadow: 0 2px 4px rgba($color: #000000, $alpha: 0.1);
            .linkWrap {
              margin-right: 0;
              height: 50px;
              border-bottom: 1px solid rgba($color: #000000, $alpha: 0.1);
              .link {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                .linkName {
                  color: #000000;
                }
              }
            }
          }
        }
        .right-wrap {
          .changeLans {
            .languageNameBase {
              .icon {
                display: none;
              }
            }
          }
          .menuBtn {
            display: flex;
            margin-left: 0.5rem;
          }
        }
        .nav {
          display: none;
        }
      }
    }
  }
</style>

<style lang="scss">
  .userPanel {
    padding: 20px;
    min-width: 220px;
    .userInfoItem {
      margin-bottom: 14px;
      display: flex;
      font-family: Helvetica;
      font-size: 14px;
      color: #09123B;
      .itemKey {
        font-weight: 700;
      }
      .itemVal {
        margin-left: 10px;
      }
    }
    .logoutBtn {
      margin-top: 24px;
      font-size: 14px;
      font-weight: 700;
      height: 30px;
      line-height: 30px;
      border-radius: 8px;
      color: #000000;
      background: #FFE113;
      box-shadow: 0 1px 5px 0 #ffb40075;
      padding: 0 10px;
      text-align: center;
      cursor: pointer;
      transition: all .3s;
      &:hover {
        background: #ffca13;
      }
    }
  }
</style>